import { logger } from '../../../../utils/logger';

/**
 * Intercepts AudioCodes incomingCall and auto-answers SIP to establish WebRTC.
 * CXone API-level accept is still required separately.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function installSipAutoAnswer(audioCode: any): void {
  if (!audioCode) {
    logger.warn('[CXone SDK] Cannot install SIP auto-answer: audioCode not available');
    return;
  }

  if (audioCode.__sipAutoAnswerInstalled) {
    return;
  }

  logger.debug('[CXone SDK] Installing SIP-level auto-answer...');

  const existingListeners = audioCode.listeners;

  if (existingListeners && typeof existingListeners.incomingCall === 'function') {
    const originalIncomingCall = existingListeners.incomingCall;

    existingListeners.incomingCall = function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      call: any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      invite: any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      replacedCall: any,
      hasSDP: boolean
    ) {
      logger.debug('[CXone SDK] SIP incoming call detected, auto-answering...');
      logger.debug('[CXone SDK]   call:', call?.data);
      logger.debug('[CXone SDK]   hasSDP:', hasSDP);

      originalIncomingCall(call, invite, replacedCall, hasSDP);

      try {
        if (call && typeof call.answer === 'function') {
          logger.debug('[CXone SDK] Calling call.answer() to establish WebRTC...');
          call.answer({
            mediaConstraints: { audio: true, video: false },
          });
          logger.debug('[CXone SDK] SIP auto-answer initiated');
        } else {
          logger.warn('[CXone SDK] Cannot auto-answer: call.answer() not available');
        }
      } catch (err) {
        logger.error('[CXone SDK] SIP auto-answer failed:', err);
      }
    };

    logger.debug('[CXone SDK] SIP auto-answer listener wrapped successfully');
  } else {
    logger.warn('[CXone SDK] Cannot install SIP auto-answer: incomingCall listener not found');

    if (typeof audioCode.setListeners === 'function') {
      logger.debug('[CXone SDK] Trying to add incomingCall listener via setListeners...');
    }
  }

  audioCode.__sipAutoAnswerInstalled = true;
}
